<template>
  <section class="page-link-filter initialized" :style="containerStyles" data-callback-change="CALENDAR-FILTER-CHANGE"
           @click.stop>
    <div class="viewport">
      <div class="filter-area filter-calendar">
        <h3 @click.prevent="isFilterOpen = !isFilterOpen">Filter</h3>
        <a title="Filter" class="drop-down-handle" :class="{active: isFilterOpen}" href="#"
           @click.prevent="isFilterOpen = !isFilterOpen">
          <svg class="open">
            <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#symbol_filter_list"></use>
          </svg>
          <svg class="close">
            <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#symbol_close_circle"></use>
          </svg>
        </a>
        <a class="filter-count" :class="{show: selectedFilterValues.length}" href="#" @click.prevent="clearFilters"
           title="Clear Filters">
          Clear Filter<span v-show="selectedFilterValues.length > 1">s</span>
        </a>

        <widget-filters :filters="availableFilters" :is-filter-open="isFilterOpen"
                        @close="isFilterOpen = false" @update-filter="updateFilter"></widget-filters>
      </div>
      <div class="clearme"></div>
    </div>
  </section>
</template>

<script>
/*!
 * Copyright (C) 2022, Peppermill Inc.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are not permitted.
 *//*
 *		2022-08-19
 *			- Refactor filter-widget.js calendar-related functionality to <calendar-filter-widget> component.
 */

import WidgetFilters from "../widget-filters.vue";
import {getSelectedFilters} from "../../helpers/get-selected-filters";

export default {
  name: 'calendarFilterWidget',
  components: {
    WidgetFilters,
  },
  props: {},
  mounted: function () {
    $(this.initialize);
  },
  data: function () {
    return {
      isInitialized: false,

      filterCacheLabel: 'calendar-filter-widget-selections',
      savedFilterData: {},
      isFilterOpen: false,
      filterSaveTimeout: 500,
      eventTypesFound: [],
      selectedFilterValues: [],
      filters: [
        {
          title: 'Gaming',
          key: 'gaming',
          items: [
            {
              title: 'Gaming',
              value: 'Gaming',
              selected: false
            },
            {
              title: 'Slot Tournaments',
              value: 'Slot Tournaments',
              selected: false
            },
            {
              title: 'Poker Tournaments',
              value: 'Poker Tournaments',
              selected: false
            },
            {
              title: 'Race / Sportsbook',
              value: 'Race / Sportsbook',
              selected: false
            },
            {
              title: 'Keno',
              value: 'Keno',
              selected: false
            },
            {
              title: 'Casino Promotions',
              value: 'Casino Promotions',
              selected: false
            },
            {
              title: 'Tournaments',
              value: 'Tournaments',
              selected: false
            },
            {
              title: '40K Slot Tournaments',
              value: '40K Slot Tournaments',
              selected: false
            },
            {
              title: 'Comp Multipliers',
              value: 'Comp Multipliers',
              selected: false
            },
          ]
        },
        {
          title: 'Resort',
          key: 'resort',
          items: [
            {
              title: 'Dining Events',
              value: 'Dining Events',
              selected: false
            },
            {
              title: 'White Orchid Wine Series',
              value: 'White Orchid Wine Series',
              selected: false
            },
            {
              title: 'Entertainment',
              value: 'Entertainment',
              selected: false
            },
            {
              title: 'EDGE',
              value: 'EDGE',
              selected: false
            },
            {
              title: 'Terrace Lounge',
              value: 'Terrace Lounge',
              selected: false
            },
            {
              title: 'Spa',
              value: 'Spa',
              selected: false
            },
            {
              title: 'Arcade',
              value: 'Arcade',
              selected: false
            },
            {
              title: 'Resort',
              value: 'Resort',
              selected: false
            },
            {
              title: 'Reno Events',
              value: 'Reno Events',
              selected: false
            },
            {
              title: 'Dining Specials',
              value: 'Dining Specials',
              selected: false
            },
          ]
        },
      ]
    };
  },
  watch: {
    filters: {
      handler: function () {
        this.selectedFilterValues = this.getSelectedFilterValues();
        document.querySelectorAll('#calendar-wrapper .event').forEach(eventNode => {
          if (0 === this.selectedFilterValues.length) {
            eventNode.classList.remove('hidden');
          } else {
            const eventCategories = JSON.parse(eventNode.dataset.cats || '[]');
            for (let i = 0, l = eventCategories.length; i < l; i++) {
              if (-1 !== this.selectedFilterValues.indexOf(eventCategories[i])) {
                eventNode.classList.remove('hidden');
                return;
              }
            }

            eventNode.classList.add('hidden');
          }

        });
      },
      deep: true
    }
  },
  computed: {
    availableFilters: function () {
      let output = [];
      for (let filterKey in this.filters) {
        let itemsAvailable = [];
        this.filters[filterKey].items.forEach(filterItem => {
          if (-1 !== this.eventTypesFound.indexOf(filterItem.value)) {
            itemsAvailable.push(filterItem);
          }
        });
        if (itemsAvailable.length) {
          output.push({
            title: this.filters[filterKey].title,
            key: this.filters[filterKey].key,
            items: itemsAvailable
          });
        }
      }

      return output;
    },

    containerStyles: function () {
      let output = {};

      if (0 === this.availableFilters.length) {
        output['display'] = 'none';
      }

      return output;
    }
  },
  methods: {
    initialize: function () {
      document.addEventListener('click', () => {
        this.isFilterOpen = false;
      });

      this.setAvailableEventTypes()

      this.getSavedFilterData();

      this.setDeepLinks();

      this.isInitialized = true;
    },
    getSavedFilterData: function () {
      const cachedFilterData = pepHelperFunctions.getCachedData(this.filterCacheLabel, 1800000) || {};
      if (cachedFilterData.hasOwnProperty('DATA') && cachedFilterData.DATA.hasOwnProperty('filters')) {
        for (let key in cachedFilterData.DATA.filters) {
          cachedFilterData.DATA.filters[key].forEach(value => {
            this.updateFilter({
              key,
              value,
              selected: true
            });
          });
        }
      }
    },

    updateFilter: function (payload) {
      let saveChange = false;
      if ('object' === typeof payload && payload.hasOwnProperty('key') && payload.hasOwnProperty('value') && payload.hasOwnProperty('selected')) {
        this.filters.forEach((filterType, filterIndex) => {
          if (filterType.key === payload.key) {
            filterType.items.forEach((filterValue, filterValueIndex) => {
              if (filterValue.value === payload.value && this.filters[filterIndex].items[filterValueIndex].selected !== !!payload.selected) {
                saveChange = true;
                this.filters[filterIndex].items[filterValueIndex].selected = !!payload.selected;
              }
            });
          }
        });
      }

      //persist filter change if any occurred
      if (true === saveChange) {
        clearTimeout(this.filtersaveTimer);

        this.filtersaveTimer = setTimeout(() => {
          pepHelperFunctions.setCachedData(
              'hotel-filter-widget-selections',
              {
                filters: getSelectedFilters(this.filters)
              }
          );
        }, this.filterSaveTimeout);
      }
    },

    setAvailableEventTypes: function () {
      this.eventTypesFound = [];
      document.querySelectorAll('#calendar-wrapper .event').forEach(eventNode => {
        JSON.parse(eventNode.dataset.cats || '[]').forEach(category => {
          if (-1 === this.eventTypesFound.indexOf(category)) {
            this.eventTypesFound.push(category);
          }
        });
      });
    },

    setDeepLinks: function () {
      const deepLinkCategories = this.getDeepLinkCategories();
      this.filters.forEach(filter => {
        deepLinkCategories.forEach(category => this.updateFilter({
          key: filter.key,
          value: category,
          selected: true
        }));
      });
    },
    getDeepLinkCategories: function () {
      let deepLinkCategories = window.pepHelperFunctions.getParameterByName('cat');
      if ('' !== deepLinkCategories) {
        if ('string' === typeof deepLinkCategories) {
          deepLinkCategories = [deepLinkCategories];
        }

        return deepLinkCategories;
      }

      return [];
    },

    getSelectedFilterValues: function () {
      const selectedFilters = getSelectedFilters(this.filters);
      let selectedFilterValues = [];
      for (let filterKey in selectedFilters) {
        selectedFilters[filterKey].forEach(filterItem => {
          selectedFilterValues.push(filterItem);
        });
      }

      return selectedFilterValues;
    },

    clearFilters: function () {
      this.filters.forEach(filter => {
        for (let i = 0, l = filter.items.length; i < l; i++) {
          filter.items[i].selected = false;
        }
      });
    },
  }
}
</script>

<style scoped>

</style>